module.exports = __webpack_public_path__ + "static/img/icon_login_top_bg.a9370d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_login_top_bg.png
// module id = pr+4
// module chunks = 5